<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
	<mat-tree-node
		*matTreeNodeDef="let node; when: hasChild"
		[style.display]="isNodeVisible(node.data) ? null : 'none'"
	>
		<div class="mat-tree-node" [style.padding-left.px]="node.level * 20">
			<button
				mat-icon-button
				matTreeNodeToggle
				[attr.aria-label]="'Toggle ' + node.name"
			>
				<mat-icon class="mat-icon-rtl-mirror">
					{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
				</mat-icon>
			</button>
			<mat-checkbox
				[checked]="descendantsAllSelected(node)"
				[indeterminate]="descendantsPartiallySelected(node)"
				(change)="itemSelectionToggle(node)"
			>
				{{ node.name }}
			</mat-checkbox>
		</div>
	</mat-tree-node>

	<mat-tree-node
		*matTreeNodeDef="let node"
		[style.display]="isNodeVisible(node.data) ? null : 'none'"
	>
		<div
			class="mat-tree-node"
			[class.tree-branch-row]="node.level > 0"
			[class.tree-leaf-row]="node.level > 0"
			[style.padding-left.px]="node.level * 20"
			[style.--tree-level]="node.level"
		>
			<mat-checkbox
				class="tree-leaf-checkbox"
				[checked]="checklistSelection.isSelected(node)"
				(change)="leafItemSelectionToggle(node)"
			>
				{{ node.name }}
			</mat-checkbox>
		</div>
	</mat-tree-node>
</mat-tree>
